import { createRouter, createWebHistory } from 'vue-router'
import index from '@/views/index.vue'

const routes = [
  {
    path: '/',
    name: 'Index',
    component: index,
  },
  {
    path: '/result/:uuid',
    name: 'Result',
    component: () => import('@/views/result.vue'),
  },
  {
    path: '/auth',
    component: () => import('@/views/auth.vue'),
    children: [
      {
        path: '/login',
        component: () => import('@/views/auth/login.vue'),
      },
      {
        path: '/forgot-password',
        component: () => import('@/views/auth/forgot-password.vue'),
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'Not Found',
    component: () => import('@/views/404.vue'),
  },
];

const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),
  history: createWebHistory('/'),
  routes,
});

export default router;